import React from "react"
import { Box } from "@mui/material"
import { AppFormDrawer, AppFormGrid, AppFormSection } from "@components"
import { autoEuropeProviderNormalizationDrawerData, isAutoEuropeProviderNormalizationDrawerOpen, clearAutoEuropeProviderNormalizationSignals } from "Pages/AutoEuropeTool/ProviderNormalization/@signals"
import AutoEuropeProviderNormalizationFooter from "Pages/AutoEuropeTool/ProviderNormalization/@components/Footer"
import AutoEuropeProviderNormalizationProviderField from "Pages/AutoEuropeTool/ProviderNormalization/@components/ProviderField"
import AutoEuropeProviderNormalizationAutoEuropeProviderField from "Pages/AutoEuropeTool/ProviderNormalization/@components/AutoEuropeProviderField"
import AutoEuropeProviderNormalizationFilterModeField from "Pages/AutoEuropeTool/ProviderNormalization/@components/FilterModeField"

export default function AutoEuropeProviderNormalizationDrawer({ onSubmit, isLoading }) {
	return <AppFormDrawer
		icon="arrows-left-right"
		title={autoEuropeProviderNormalizationDrawerData.value._isEditing ? "Edit Provider Normalization" : "Create Provider Normalization"}
		subtitle="How a provider is named in AutoEurope"
		width="40%"
		variant="persistent"
		isOpen={isAutoEuropeProviderNormalizationDrawerOpen.value}
		controller={clearAutoEuropeProviderNormalizationSignals}
		footer={<AutoEuropeProviderNormalizationFooter onSubmit={onSubmit} isLoading={isLoading}/>}
	>
		<AppFormSection icon="arrows-left-right" title="Provider">
			<AppFormGrid>
				<Box sx={{ gridColumn: 'span 12' }}><AutoEuropeProviderNormalizationProviderField/></Box>
				<Box sx={{ gridColumn: 'span 12' }}><AutoEuropeProviderNormalizationAutoEuropeProviderField/></Box>
				<Box sx={{ gridColumn: 'span 12' }}><AutoEuropeProviderNormalizationFilterModeField/></Box>
			</AppFormGrid>
		</AppFormSection>
	</AppFormDrawer>
}
